/* Global imports. */
import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { ImageElement } from "@kontent-ai/gatsby-components";

import KontentRichText from "@components/KontentRichText";
import { cleanStringForPath } from "@src/helpers";

interface Props {
  kontentImage?: any;
  remoteImage?: any;
  contributorName: string;
  contributorId: string;
  description?: any;
  linkText?: string;
  linkUrl?: string;
  componentID?: string
}

const ContributorSpotlight = ({ kontentImage, remoteImage, contributorName, contributorId, description, linkText="Find out more", linkUrl, componentID }: Props) =>{
  const ConditionalWrapper = ({ condition, wrapper, children }) => condition ? wrapper(children) : children;

  return (
    <div id={componentID} data-component="contributor-spotlight" className="col-span-full sm:col-span-4">
      <ConditionalWrapper
        condition={!linkUrl}
        wrapper={(children:any) => (
          <Link to={`/authors/${cleanStringForPath(contributorName)}/${contributorId}`}>{children}</Link>
        )}
      >
        <React.Fragment>
          <figure className="featured-contributor">
              {kontentImage && (
                <ImageElement 
                  image={kontentImage}
                  alt={kontentImage.description ? kontentImage.description : kontentImage.name}
                  width={kontentImage.width}
                  height={kontentImage.height}
                  className="w-full rounded-md"
                />
              )}
              {remoteImage && (
                <img src={remoteImage} alt={contributorName} className="rounded-md" width="350" height="531" />
              )}
            <figcaption className="mt-8 sm:mt-4">
              <h3>{contributorName}</h3>
              {description && <KontentRichText value={description} />}
              {linkUrl && (
                <a href={linkUrl} className="button" target="_blank">
                  {linkText}
                </a>
              )}
            </figcaption>
          </figure>
        </React.Fragment>
      </ConditionalWrapper>
    </div>
  )
};

export default ContributorSpotlight;